package com.jingfangpai.diagnosisSetting.model

import com.jingfangpai.common.orm.mapping.SignSymptomSetting
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomSettingDto: SignSymptomSetting() {
    var signSymptomName:SignSymptomName?=null
    var accompaniedBy:Set<SignSymptomSettingAccompaniedByDto> = setOf()
    var relievedBy:Set<SignSymptomSettingRelievedByDto> = setOf()
    var triggeredWorsenedBy:Set<SignSymptomSettingTriggeredWorsenedByDto> = setOf()
}